import getConfig from 'next/config';
import * as Styled from './SubmitPanel.styled';

type SubmitPanelProps = {
  isSubmitting: boolean;
};

const SubmitPanel = (props: SubmitPanelProps) => {
  const {
    publicRuntimeConfig: { CDN_STATIC_ASSETS },
  } = getConfig();
  const { isSubmitting } = props;

  return (
    <Styled.Content>
      <Styled.SubmitButton type="submit" disabled={isSubmitting}>
        <Styled.Spinner
          isSubmitting={isSubmitting}
          cdnUrl={CDN_STATIC_ASSETS}
        />
        <Styled.ButtonText isSubmitting={isSubmitting}>
          Submit Application
        </Styled.ButtonText>
      </Styled.SubmitButton>
    </Styled.Content>
  );
};

export { SubmitPanel };
